import { FC } from "react";
import UserStore from "../contexts/userStore";

const NewTaxCasesBadge: FC = () => {
  const { newTaxCasesCount } = UserStore?.useContainer();

  if (!newTaxCasesCount || newTaxCasesCount <= 0) {
    return null;
  }

  return <span className="status-badge status-badge-blue-outline">{newTaxCasesCount}</span>;
};

export default NewTaxCasesBadge;
